const TESTIMONIALS = [
  {
    quote: "The personal attention makes all the difference. Our support worker is punctual, compassionate, and has become a trusted part of our weekly routine.",
    name: "Family Carer",
    location: "Adelaide Southern Suburbs",
  },
  {
    quote: "As a Support Coordinator, finding providers with immediate capacity who actually communicate is rare. Beneficence Care is now top of my referral list.",
    name: "NDIS Support Coordinator",
    location: "South Australia Statewide",
  },
  {
    quote: "Having help with household tasks and daily appointments gave me my independence back. The online booking calendar made scheduling easy.",
    name: "NDIS Participant",
    location: "Adelaide Hills",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="py-20 px-5 sm:px-8 bg-[#FAF8F5]" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto space-y-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Client Voices</span>
            <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D] mt-2">What families & coordinators value most</h2>
          </div>
          <p className="text-xs text-[#6B7980]">Verified South Australian client & coordinator feedback</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} data-testid={`testimonial-${t.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="p-6 rounded-2xl bg-[#F6F1EA] border border-[#E7E0D3] flex flex-col justify-between space-y-4">
              <div className="space-y-3">
                <div className="text-amber-800 text-sm">★★★★★</div>
                <p className="text-sm text-[#3E4C53] leading-relaxed italic">"{t.quote}"</p>
              </div>
              <div className="pt-3 border-t border-[#E3D9CB] text-xs">
                <div className="font-semibold text-[#1E282D]">{t.name}</div>
                <div className="text-[#647279]">{t.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
